import { createFileRoute, Link } from '@tanstack/react-router';
import { Button } from '~/components/ui/button';

const APP_NAME = import.meta.env.VITE_APP_NAME ?? '{{APP_NAME}}';

export const Route = createFileRoute('/')({
  component: Landing,
});

function Landing() {
  return (
    <section className="mx-auto max-w-2xl px-6 py-24 sm:py-32 animate-rise-soft">
      <div className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground mb-6">
        a place to be honest
      </div>
      <h1 className="font-serif text-[44px] sm:text-[56px] leading-[1.05] tracking-tight">
        {APP_NAME}.
      </h1>
      <p className="mt-6 text-[17px] sm:text-[19px] text-muted-foreground leading-[1.55] max-w-[58ch]">
        A quiet platform that learns who you are — your personality, your
        patterns, your fears — and meets you with the right move at the right
        moment. Two modes: <span className="text-foreground">Founder</span>,
        for inventors and CEOs whose time has eaten their identity, and{' '}
        <span className="text-foreground">Human</span>, for everyone else
        learning to understand, forgive, and love themselves.
      </p>

      <div className="mt-10 flex flex-wrap items-center gap-3">
        <Link to="/login">
          <Button size="lg">Begin</Button>
        </Link>
        <Link to="/login">
          <Button size="lg" variant="ghost">
            I already have an account
          </Button>
        </Link>
      </div>

      <hr className="my-12 border-t border-border" />

      <dl className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-sm">
        <div>
          <dt className="font-serif text-base text-foreground">Honest</dt>
          <dd className="mt-2 text-muted-foreground leading-relaxed">
            The coach won't tell you you're doing great when the data shows otherwise.
          </dd>
        </div>
        <div>
          <dt className="font-serif text-base text-foreground">Private by design</dt>
          <dd className="mt-2 text-muted-foreground leading-relaxed">
            Per-user encrypted entries. No cross-user reads. Default-off
            community.
          </dd>
        </div>
        <div>
          <dt className="font-serif text-base text-foreground">ADHD-first</dt>
          <dd className="mt-2 text-muted-foreground leading-relaxed">
            One input box. Voice when you can't type. No streaks. No daily
            quests.
          </dd>
        </div>
      </dl>
    </section>
  );
}
